import { HttpResponse } from '@/clients/http'

/** Gives a device-database read the http client's envelope, so models and hooks do not care where data lives. */
export const local = async <T>(work: Promise<T>): Promise<HttpResponse<T>> => {
  try {
    return { success: true, data: await work }
  } catch (error) {
    return { success: false, error: { status: 0, message: (error as Error).message } }
  }
}
